// extracted by mini-css-extract-plugin
export default {"container":"vE-z","dimension":"wE-z","dimensionLabels":"xE-z"};